import { Globe } from "@/components/Svg";
import CMultiSelect from "@/components/main/form/CMultiSelect";
import CSelect from "@/components/main/form/CSelect";
import firebase_app from "@/lib/firebase/configs";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { IconBuildingBank, IconBuildingCommunity } from "@tabler/icons-react";
import {
  addDoc,
  collection,
  endAt,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAt,
} from "firebase/firestore";
import { useEffect, useState } from "react";

const FinancingAgenciesInput = ({ dictionary, form }) => {
  const [financingAgenciesData, setFinancingAgenciesData] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);

  const createFinancingAgencie = async (name) => {
    try {
      const db = getFirestore(firebase_app);
      await addDoc(collection(db, "FinancingAgencies"), {
        name: name,
        lowerCaseName: name.toLowerCase(),
      });
    } catch (error) {}
  };

  const getFinancingAgencie = async (search, inital = false) => {
    try {
      setLoading(true);
      const db = getFirestore(firebase_app);
      const q = inital
        ? query(
          collection(db, "FinancingAgencies"),
          orderBy("lowerCaseName"),
          limit(4)
        )
        : query(
          collection(db, "FinancingAgencies"),
          orderBy("lowerCaseName"),
          startAt(search.toLowerCase()),
          endAt(search.toLowerCase() + "\uf8ff"),
          limit(4)
        );
      const querySnapshot = await getDocs(q);
      let financingAgenciesDataQueried = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        financingAgenciesDataQueried.push(data?.name);
      });
      setFinancingAgenciesData(financingAgenciesDataQueried);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFinancingAgencie("", true);
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getFinancingAgencie(search);
    }
  }, [search]);

  return (
    <CMultiSelect
      data={
        form.values.experienceWithFinancingAgencies
          ? Array.from(
            new Set([
              ...form.values.experienceWithFinancingAgencies,
              ...financingAgenciesData,
            ])
          )
          : financingAgenciesData
      }
      searchable
      creatable
      placeholder={dictionary.experienceWithFinancingAgencies}
      className="mt-3"
      icon={<IconBuildingBank />}
      limit={5}
      hoverOnSearchChange={true}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      onCreate={(value) => {
        createFinancingAgencie(value);
        setFinancingAgenciesData((data) => [...data, value]);
        form.setValues({
          experienceWithFinancingAgencies: [
            ...form.values.experienceWithFinancingAgencies,
            value,
          ],
        });
      }}
      getCreateLabel={(query) => {
        return (
          <>
            <span className="text-primary">{dictionary.createItem}: </span>
            {query}
          </>
        );
      }}
      filter={(value, selected, item) => {
        return (
          item.value.toLowerCase().startsWith(value.toLowerCase()) && !selected
        );
      }}
      rightSection={loading && <Loader variant="oval" size={26} />}
      {...form.getInputProps("experienceWithFinancingAgencies")}
    />
  );
};

export default FinancingAgenciesInput;
